module.exports = __webpack_public_path__ + "img/heading-square.5a501d24.svg";